// NOTE: WPで読み込まれているjQueryを使用するためimportしないでみる
// import $ from "jquery";
import lozad from 'lozad';
import SmoothScroll from 'smooth-scroll';
// import luminousLightbox from './luminous';
import sticky from './sticky';
// import ScrollOut from 'scroll-out';

// modules
import Common from "./Common";
import FrontPage from "./FrontPage";
import SinglePage from "./SinglePage";
// ./qrCodeStyling.jsをimportする
import qrCodeStyling from "./qrCodeStyling";

// // Sass/cssファイルの読み込み
import "animate.css";
import "sticky-state/dist/sticky-state.css"
import 'normalize.css';
import "../sass/style.scss";

$(function(){

   // loazed.js Intersection ObserverによるLazyLoad
   // ref:https://qiita.com/yukagil/items/369a9972fd45223677fd
   // ref:https://www.rectus.co.jp/archives/358#IE_Polyfill
   const observer = lozad();
   // loazed.js Intersection ObserverによるLazyLoad
   observer.observe();

   // SmoothScroll発火
   // ページ内でのアンカーリンクに対して機能する
   const scroll = new SmoothScroll('[data-smooth-scroll]', {
      header: '[data-scroll-header]'
   });

   // // lightbox
   // luminousLightbox();

   // sticky state
   sticky();

   new Common();
   new FrontPage();
   new SinglePage();

   qrCodeStyling();
});

